// @ts-nocheck

import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import NumberFormatter from '../../utils/NumberFormater';
import { getFund } from '../../redux/slice/fundAndTransactionSlice';
import { RootState } from '../../redux/types';

// Types for props
interface FundsHeaderProps {
  viewAllAuctionLink?: any;
  isMyBidMobile?: boolean;
  funds: {
    availableFund?: number;
    lockedFund?: number;
  } | null;
}

export const FundsHeader: React.FC<FundsHeaderProps> = ({ viewAllAuctionLink, funds, isMyBidMobile }) => {
  const dispatch = useDispatch();
  const { investorId } = useSelector((state: RootState) => state?.user);

  useEffect(() => {
    const fetchFunds = async () => {
      try {
        await dispatch(getFund(investorId)).unwrap();
      } catch (error) {
        console.error('Failed to fetch fund:', error);
        // Optionally: set some error state here
      }
    };

    if (investorId) {
      fetchFunds();
    }
  }, [investorId, dispatch]);

  const { fundsData } = useSelector((store: RootState) => store.fund) || {};

  return (
    isMyBidMobile ? (
      <div
        className="flex flex-row gap-3 justify-end m-auto rounded-b-lg bg-[#087CA729] p-2 w-fit xl:float-right xs:mt-0 md:mt-6 lg:mt-0 xl:mt-0"
        data-testid="funds-display"
      >
        <div className="bg-white p-2 text-sm xl:text-base rounded" data-testid="available-funds">
          Available Funds <strong className="text-base">$<NumberFormatter amount={funds?.availableBalance !== undefined ? funds?.availableBalance : fundsData?.availableFund} /></strong>
        </div>
        <div className="bg-white p-2 text-sm xl:text-base rounded" data-testid="locked-funds">
          Locked Funds <strong className="text-base">$<NumberFormatter amount={funds?.lockedBalance !== undefined ? funds?.lockedBalance : fundsData?.lockedFund} /></strong>
        </div>
      </div>
    ) : (
      <div className="flex flex-col sm:items-center sm:flex-row justify-between items-start gap-4 sm:mt-5 md:mt-0 xs:mt-0" data-testid="funds-header">
        {/* Live Auctions / Today's Auctions */}
        <div
          className={`font-semibold text-darkGray items-end ${viewAllAuctionLink ? "text-xl xl:text-[28px] ml-0 sm:ml-[25px]" : "text-xl"}`}
          data-testid="auction-title"
          role="heading" aria-level="1"
        >
          {viewAllAuctionLink ? "Live" : "Today's"} Auctions
        </div>
        <div className="flex flex-col sm:flex-row justify-end items-center gap-3 sm:gap-5">
          {/* View All Auctions (only visible on desktop) */}
          {/* {viewAllAuctionLink && (
        <div
          className="hidden sm:block underline cursor-pointer text-sm xl:text-base font-medium mb-1"
          data-testid="view-all-auctions"
        >
          View All Auctions
        </div>
      )} */}

          {/* Available Funds and Locked Funds */}
          <div
            className="flex flex-row gap-3 justify-end m-auto rounded-b-lg bg-[#087CA729] p-2 w-fit xl:float-right xs:mt-0 md:mt-6 lg:mt-0 xl:mt-0"
            data-testid="funds-display"
          >
            <div className="bg-white p-2 text-sm xl:text-base rounded" data-testid="available-funds">

              Available Funds <strong className="text-base">$<NumberFormatter amount={funds?.availableBalance !== undefined ? funds?.availableBalance : fundsData?.availableFund} /></strong>
            </div>

            <div className="bg-white p-2 text-sm xl:text-base rounded" data-testid="locked-funds">
              Locked Funds <strong className="text-base">$<NumberFormatter amount={funds?.lockedBalance !== undefined ? funds?.lockedBalance : fundsData?.lockedFund} /></strong>
            </div>
          </div>
        </div>
      </div>
    )

  );
};
